export default "__VITE_ASSET__BsQgZXvA__"